<template>
  <div class="content-wrapper">
    <div class="container">
      <article>
        <div class="step-bar-container">
          <ul>
            <li class="li-step">
              <span class="stepnum num01"></span>
              <span class="steptext">条件入力</span>
            </li>
            <li class="li-step">
              <span class="stepnum num02"></span>
              <span class="steptext">見積り確認</span>
            </li>
            <li class="li-step active">
              <span class="stepnum num03"></span>
              <span class="steptext">連絡先入力</span>
            </li>
            <li class="li-step">
              <span class="stepnum num04"></span>
              <span class="steptext">最終確認</span>
            </li>
          </ul>
        </div>
        <div class="section white-panel mb2p pb8">
          <p class="fs13 color-font2">店舗から日程調整のお電話をさせていただきます。お客様の電話番号と連絡を希望する時間帯（あれば）をご入力ください。</p>
        </div>
        <div class="section white-panel mb2p">
          <section class="pb20">
            <h2 id="tel" class="fs16 font-weight-bold mb12">連絡先の電話番号</h2>
            <input v-model="inspection.tel" type="tel" placeholder="(例)09012345678" class="fs14 pl-text-left w100p" v-bind:class="{ 'error': form.telErrorMessage }">
            <p class="mt8 mb0 error">{{form.telErrorMessage}}</p>
          </section>
          <section class="pb20">
            <h2 id="userRequest" class="fs16 font-weight-bold mb12">連絡を希望する時間帯（あれば）</h2>
            <textarea v-model="inspection.user_request" name="" id="" cols="30" rows="2" placeholder="(例)休日または平日18時以降" class="fs14 pl-text-left w100p" v-bind:class="{ 'error': form.userRequestErrorMessage }"></textarea>
            <p class="mt8 mb0 error">{{form.userRequestErrorMessage}}</p>
          </section>
          <section class="pb20">
            <h2 class="fs16 font-weight-bold mb4">代車のご利用</h2>
            <p class="color-font2">代車料金が見積りと別途かかります</p>
            <fieldset class="radio-check text-left">
              <input id="item-1" class="radio-inline_input" type="radio" name="radio" value=true v-model="inspection.replacement_vehicle_requested">
              <label class="radio-inline_label" for="item-1">必要</label>
              <input id="item-2" class="radio-inline_input" type="radio" name="radio" value=false checked="checked" v-model="inspection.replacement_vehicle_requested">
              <label class="radio-inline_label" for="item-2">不要</label>
            </fieldset>
          </section>
          <div class="bg-gray1 pd12">
            <p class="fs13 line-height1_6 mb4 color-font2">車検所要時間の目安</p>
            <p class="fs13 line-height1_6 mb0 color-font2">{{ ssInfo.carcare_duration_standard }}</p>
          </div>
        </div>
        <section class="section white-panel pb0 pr0">
          <h2 class="fs16 font-weight-bold">車検実施店舗</h2>
          <table class="table w100p fs14">
            <tbody>
              <tr>
                <th class="bdb-solid-gray1 color-font2 font-weight-normal pb12 pt12 w25p">店舗名</th>
                <td class="bdb-solid-gray1 pb12 pt12 pl2p pr2p">{{ ssInfo.ss_name }}</td>
              </tr>
              <tr>
                <th class="bdb-solid-gray1 color-font2 font-weight-normal pb12 pt12">住所</th>
                <td class="bdb-solid-gray1 pb12 pt12 pl2p pr2p">{{ ssInfo.address }}</td>
              </tr>
              <tr>
                <th class="bdb-solid-gray1 color-font2 font-weight-normal pb12 pt12">電話番号</th>
                <td class="bdb-solid-gray1 pb12 pt12 pl2p pr2p disable-auto-tel">{{ ssInfo.tel }}</td>
              </tr>
              <tr v-if="ssInfo.opening_hours_weekday || ssInfo.opening_hours_saturday || ssInfo.opening_hours_sunday || ssInfo.opening_hours_holiday">
                <th class="bdb-solid-gray1 color-font2 font-weight-normal pb12 pt12">営業時間</th>
                <td class="bdb-solid-gray1 pb12 pt12 pl2p pr2p">
                  <template v-if="ssInfo.opening_hours_weekday">平日 {{ ssInfo.opening_hours_weekday }}<br></template>
                  <template v-if="ssInfo.opening_hours_saturday">土曜 {{ ssInfo.opening_hours_saturday }}<br></template>
                  <template v-if="ssInfo.opening_hours_sunday">日曜 {{ ssInfo.opening_hours_sunday }}<br></template>
                  <template v-if="ssInfo.opening_hours_holiday">祝日 {{ ssInfo.opening_hours_holiday }}</template></td>
              </tr>
              <tr v-if="ssInfo.opening_hours_carcare">
                <th class="bdb-solid-gray1 color-font2 font-weight-normal pb12 pt12">カーケア<br>営業時間</th>
                <td class="bdb-solid-gray1 pb12 pt12 pl2p pr2p">{{ ssInfo.opening_hours_carcare }}</td>
              </tr>
              <tr v-if="ssInfo.regular_holiday">
                <th class="bdb-solid-gray1 color-font2 font-weight-normal pb12 pt12">定休日</th>
                <td class="bdb-solid-gray1 pb12 pt12 pl2p pr2p">{{ ssInfo.regular_holiday}}</td>
              </tr>
              <tr v-if="ssInfo.factory_type_flag">
                <th class="bdb-solid-gray1 color-font2 font-weight-normal pb12 pt12">整備工場</th>
                <td v-if="ssInfo.factory_type_flag === 2" class="bdb-solid-gray1 pb12 pt12 pl2p pr2p">{{ssInfo.factory_type_name}}工場</td>
                <td v-else-if="ssInfo.factory_type_flag === 3" class="bdb-solid-gray1 pb12 pt12 pl2p pr2p">{{ssInfo.factory_type_name}}工場</td>
                <td v-else-if="ssInfo.factory_type_flag === 4" class="bdb-solid-gray1 pb12 pt12 pl2p pr2p">提携工場で整備いたします。詳細は店舗へご確認ください。</td>
              </tr>
            </tbody>
          </table>
        </section>

        <div class="section transparent-panel">
          <button @click="$emit('toConfirmCheck', inspection, form)" class="button fs16 mt8 mb16 pd16 radius200">次へ</button>
        </div>

      </article>
    </div>
  </div>
</template>

<script>

export default {
  data: () => ({
    form: {
      telErrorMessage: '',
      userRequestErrorMessage: ''
    }
  }),
  props: [
    'inspection',
    'ssInfo'
  ],
  async mounted () {
    // 戻るボタンの出し分け
    this.appDisplayBack(true)
    this.nativePVset('SHAKEN_KIBOUBI_SENTAKU')
  }
}
</script>
